export enum EActionLog {
  CREATE_RESOURCE = 'CREATE_RESOURCE',
  UPDATE_RESOURCE = 'UPDATE_RESOURCE',
  DELETE_RESOURCE = 'DELETE_RESOURCE',

  CREATE_OPU_USER = 'CREATE_OPU_USER',
  UPDATE_OPU_USER = 'UPDATE_OPU_USER',
  DELETE_OPU_USER = 'DELETE_OPU_USER',

  CREATE_ESTABLISHMENT_USER = 'CREATE_ESTABLISHMENT_USER',
  UPDATE_ESTABLISHMENT_USER = 'UPDATE_ESTABLISHMENT_USER',
  DELETE_ESTABLISHMENT_USER = 'DELETE_ESTABLISHMENT_USER',

  CREATE_STUDENT = 'CREATE_STUDENT',
  UPDATE_STUDENT = 'UPDATE_STUDENT',
  UPDATE_STUDENT_BULK = 'UPDATE_STUDENT_BULK',
  DELETE_STUDENT = 'DELETE_STUDENT',
  DELETE_STUDENT_BULK = 'DELETE_STUDENT_BULK',
  CHANGE_STUDENT_STATUS = 'CHANGE_STUDENT_STATUS',
  UPDATE_STUDENT_PROFILE = 'UPDATE_STUDENT_PROFILE',

  CREATE_CONTACT = 'CREATE_CONTACT',

  CREATE_ESTABLISHMENT = 'CREATE_ESTABLISHMENT',
  UPDATE_ESTABLISHMENT = 'UPDATE_ESTABLISHMENT',
  DELETE_ESTABLISHMENT = 'DELETE_ESTABLISHMENT',

  CREATE_CONTRACT = 'CREATE_CONTRACT',
  UPDATE_CONTRACT = 'UPDATE_CONTRACT',
  DELETE_CONTRACT = 'DELETE_CONTRACT',

  CREATE_BOOK = 'CREATE_BOOK',
  UPDATE_BOOK = 'UPDATE_BOOK',
  DELETE_BOOK = 'DELETE_BOOK',

  CREATE_AUTHOR = 'CREATE_AUTHOR',
  UPDATE_AUTHOR = 'UPDATE_AUTHOR',
  DELETE_AUTHOR = 'DELETE_AUTHOR',
}

export enum EActionLogMessage {
  CREATE_SUPER_ADMIN = 'Création de super administrateur',
  UPDATE_SUPER_ADMIN = 'Mise à jour super administrateur',
  DELETE_SUPER_ADMIN = 'Suppression du super administrateur',

  CREATE_ADMIN = "Création d'administrateur",
  UPDATE_ADMIN = "Mise à jour  d'administrateur",
  DELETE_ADMIN = "Suppression d'administrateur",

  CREATE_ESTABLISHMENT_USER = "création de l'utilisateur de l'établissement",
  UPDATE_ESTABLISHMENT_USER = "Mise à jour de l'utilisateur de l'établissement",
  DELETE_ESTABLISHMENT_USER = "Suppression de l'utilisateur de l'établissement",

  CREATE_STUDENT = "création d'étudiant",
  UPDATE_STUDENT = "Mise à jour d'étudiant",
  UPDATE_STUDENT_BULK = 'Mise à jour des étudiants',
  DELETE_STUDENT = "Suppression d'étudiant ",
  DELETE_STUDENT_BULK = 'Suppression des étudiants',
  CHANGE_STUDENT_STATUS = "Changer le statut d'étudiant",

  CREATE_CONTACT = "création du contact pour l'etudiant ",

  CREATE_ESTABLISHMENT = "création d'etablissement",
  UPDATE_ESTABLISHMENT = "Mise à jour d'etablissement",
  DELETE_ESTABLISHMENT = "Suppression d'etablissement",

  CREATE_CONTRACT = 'création du Contrat',
  UPDATE_CONTRACT = 'Mise à jour du Contract',
  DELETE_CONTRACT = 'Suppression du Contract ',

  CREATE_BOOK = 'création du Livre',
  UPDATE_BOOK = 'Mise à jour du Livre',
  DELETE_BOOK = 'Suppression du Livre',

  CREATE_AUTHOR = 'création du Auteur',
  UPDATE_AUTHOR = 'Mise à jour du Auteur',
  DELETE_AUTHOR = 'Suppression du Auteur',
}
